import { curry } from "lodash/fp"

const helperIdEquals = (a: number, b: number) => {
  return a === b
}

export default curry(helperIdEquals)
